import { render, staticRenderFns } from "./landings.vue?vue&type=template&id=7d145bb6"
import script from "./landings.vue?vue&type=script&lang=js"
export * from "./landings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports